import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import { api } from "../../../../services/api/api.service";
import { API_DARTS_ACTIVE_GAME_SCORE, } from "../../../../services/api/api.urls";
import {toastr} from "react-redux-toastr";
import { ActiveGamScoreReducer, IActionGameScorePayload, IActiveTournamentGameData } from "./types";
import { TryCatch } from "../../../../services/TryCatch";
import { COMPANY_ABBR } from "../../../../common/constants/company";

const initialState: ActiveGamScoreReducer = {
    activeGameData: {} as IActiveTournamentGameData,
    loader: false
}

export const getActiveGameScoreData = createAsyncThunk<IActiveTournamentGameData, IActionGameScorePayload, { rejectValue: string }>(
    'activeGameScore/get',
    async (gameParams, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(`${API_DARTS_ACTIVE_GAME_SCORE}/${gameParams.gameType}/${gameParams.gameId}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, "Active game score error.");
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)


export const activeGameScoreSlice = createSlice({
    name: 'activeGameScore',
    reducers: {
        setActiveGameScoreData: (state, action: PayloadAction<IActiveTournamentGameData>) => {
            state.activeGameData = action.payload;
        }
    },
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getActiveGameScoreData.pending, (state: ActiveGamScoreReducer) => {
                state.loader = true;
            })
            .addCase(getActiveGameScoreData.fulfilled, (state: ActiveGamScoreReducer, action) => {
                state.activeGameData = action.payload;
                state.loader = false;
            })
            .addCase(getActiveGameScoreData.rejected, (state: ActiveGamScoreReducer) => {
                state.loader = false;
            })
    }
})

export const {setActiveGameScoreData} = activeGameScoreSlice.actions;
export default activeGameScoreSlice.reducer;
